<template>
<b-container>
  <vue-good-table
      v-if="true"
      :columns="columns"
      :rows="links"
      styleClass="vgt-table condensed table-bordered table-striped">
    <template slot="table-row" slot-scope="props">
      <div style=" text-align: center" v-if="props.column.label === 'Edit'">
                <span style="text-align: center">
                    <b-button size="sm" :disabled="true"
                              @click="updateLink(props.row)" :id="`button-${props.row['id']}`">
                            Update
                    </b-button>
                </span>
      </div>
      <span v-else-if="props.column.label === 'Link Address'">
                   <b-form-input :id="`link-${props.row['id']}`" :value="props.formattedRow[props.column.field]"
                                 v-on:click="isDisabled(props.row['id'])"></b-form-input>
      </span>
      <span v-else>
                    {{ props.formattedRow[props.column.field] }}
      </span>
    </template>
  </vue-good-table>
</b-container>
</template>

<script>

import {VueGoodTable} from "vue-good-table";
import Swal from "sweetalert2";

export default {
  name: "ResourceLinkAdmin",
  components:{
    VueGoodTable
  },
  data() {
    return {
      links: [],
      columns: [
        {
          label: "Name",
          field: "name",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Link Name', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
          }
        },
        {
          label: "Link Address",
          field: "link",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Link Address', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
          }
        },
        {
          label: "Edit",
          field: "id"
        },
        {
          label: "id",
          field: "id",
          hidden: true
        }]
    }
  },
  beforeRouteEnter(to, from, next) {
    if (localStorage.getItem('user')) {
      next(vm => {
        vm.determineLanding()
      });
    } else {
      this.$router.push("/my-account");
    }
    next();
  },
  mounted() {
    this.loadLinks();
  },
  methods: {
    isDisabled: function (id) {
      let elementId = 'button-' + id;
      document.getElementById(elementId).disabled = false;
      document.getElementById(elementId).style.background = 'green';
    },
    loadLinks: function () {
      let self = this;
      let linksUrl = "/resources/links";
      this.$http.get(linksUrl)
          .then(links => {
            self.links = links.data;
          })
    },
    getLinkPair: function (linkName) {
      let resourceLink = this.links.find(link => {
        return link.name === linkName;
      });
      return resourceLink;
    },
    determineLanding: function () {
      if (localStorage.getItem('roles').includes('admin')) {
      } else {
        this.$router.push("/my-account");
      }
    },
    updateLink: function (item) {
      this.putUpdate(item);
    },
    convertToResourceLink: function (item) {
      let updatedItem = {
        id: item.id,
        link: document.getElementById(`link-${item.id}`).value,
        name: item.name
      }
      return updatedItem;
    },
    putUpdate: function (item) {
      console.log("Item Id " + item.id);
      console.log(item);
      let updatedItem = this.convertToResourceLink(item);
      console.log(updatedItem);
      this.$http.put(`/resources/links/${item.id}`, updatedItem)
          .then(response => {
            /*            Swal.fire({
                          title: 'Link Updated',
                          text: `The Link for ${item.name} successfully updated.`,
                          icon: 'success'
                        });*/
            this.$toasted.show(`"${item.name}" Link Updated Successfully`,
                {
                  containerClass: 'super-toasty',
                  iconPack: 'fontawesome',
                  closeOnSwipe: true,
                  action: {
                    text: 'DISMISS',
                    onClick: (e, toastObject) => {
                      toastObject.goAway(0);
                    }
                  },
                  icon: {
                    name: 'fa-check-circle',
                    after: false,
                  }
                })
                .goAway(5000);
            let elementId = 'button-' + item.id;
            document.getElementById(elementId).disabled = true;
            document.getElementById(elementId).style.background = 'gray';
          }).catch(reason => {
        Swal.fire({
          title: 'Edit The Link',
          text: `Link Update failed`,
          icon: 'error'
        });
      });
    }
  }
}
</script>

<style scoped>

</style>
